/**
 * Leitura dos funis.
 *
 * `companyId` entra na assinatura por causa do GERADOR: a previa precisa
 * mostrar numeros diferentes por empresa. Ele NAO vai na query -- o tenant
 * continua vindo da sessao (lib/api.ts, decisao 1); quando a administracao
 * abrir o CRM de outra empresa em producao, a troca passa pelo servidor.
 *
 * Rota que o backend vai ter: `GET /api/funnels/:kind?from&to`, com `kind`
 * igual ao `FunnelKind` de types.ts ('carrinho_abandonado' | 'expirados').
 */

import { fetchOrSimulate, rangeQuery, type Envelope } from '../../lib/api';
import type { PeriodRange } from '../../types';
import { simularFunil } from './mock';
import type { FunnelKind, FunnelOverview } from './types';

export function fetchFunil(kind: FunnelKind, companyId: string, range: PeriodRange, signal: AbortSignal): Promise<Envelope<FunnelOverview>> {
  return fetchOrSimulate(`/api/funnels/${kind}`, rangeQuery(range), signal, () => simularFunil(kind, companyId, range));
}
